import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PencilLine } from "@phosphor-icons/react";
import api from "@/lib/api";

export default function BylineFixCard({ refreshKey }) {
  const [data, setData] = useState(null);
  const [picked, setPicked] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/me/byline-names").then((r) => { setData(r.data); setPicked([]); }).catch(() => setData(null));
  useEffect(() => { load(); }, [refreshKey]);

  if (!data || !data.current || data.names.length === 0) return null;

  const toggle = (n) => setPicked((p) => (p.includes(n) ? p.filter((x) => x !== n) : [...p, n]));

  const apply = async () => {
    setBusy(true);
    try {
      const { data: res } = await api.post("/me/byline-names/replace", { names: picked });
      toast.success(`Updated ${res.updated} recipe${res.updated === 1 ? "" : "s"} to "by ${res.current}"`);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update recipes");
    } finally { setBusy(false); }
  };

  return (
    <div className="card-recipe lg:col-span-2" data-testid="profile-byline-fix-card">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-full bg-rf-amber/20 flex items-center justify-center"><PencilLine size={20} weight="duotone" className="text-rf-orange" /></div>
        <h2 className="font-display text-2xl font-black text-rf-ink">Names on your recipes</h2>
      </div>
      <p className="text-sm text-rf-ink-soft mb-4 leading-relaxed">
        Some of your recipes still show a different &ldquo;by …&rdquo; name. Tick the ones you want changed to <b data-testid="profile-byline-current">{data.current}</b>. Leave family names like &ldquo;Grandma Rose&rdquo; unticked to keep them.
      </p>
      <div className="flex flex-wrap gap-2 mb-4">
        {data.names.map((n) => (
          <label key={n.name || "_blank"} data-testid={`profile-byline-name-${n.name || "blank"}`} className={`inline-flex items-center gap-2 px-3 py-2 rounded-full border cursor-pointer text-sm font-semibold transition-colors ${picked.includes(n.name) ? "bg-rf-amber/30 border-rf-amber" : "bg-white border-rf-ink/15"}`}>
            <input type="checkbox" checked={picked.includes(n.name)} onChange={() => toggle(n.name)} className="w-4 h-4 accent-rf-orange" />
            {n.name || <i>no name</i>} <span className="text-xs text-rf-ink-soft">({n.count})</span>
          </label>
        ))}
      </div>
      <button type="button" data-testid="profile-byline-apply" onClick={apply} disabled={busy || picked.length === 0} className="btn-amber disabled:opacity-50">
        {busy ? "Updating…" : `Change to "${data.current}"`}
      </button>
    </div>
  );
}
